module.exports = __webpack_public_path__ + "img/4.62454e6a.png";